// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies
// @generated from protobuf file "query/span_query.proto" (package "tusk.drift.query.v1", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Value } from "../google/protobuf/struct";
import { Timestamp } from "../google/protobuf/timestamp";
/**
 * @generated from protobuf message tusk.drift.query.v1.TimestampRange
 */
export interface TimestampRange {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end = 2
     */
    end?: Timestamp;
}
/**
 * Optional extraction steps applied to a JSON-backed field predicate before
 * comparisons are evaluated.
 *
 * @generated from protobuf message tusk.drift.query.v1.FieldAccess
 */
export interface FieldAccess {
    /**
     * @generated from protobuf field: tusk.drift.query.v1.CastType cast_as = 1
     */
    castAs: CastType;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.DecodeStrategy decode = 2
     */
    decode: DecodeStrategy;
    /**
     * @generated from protobuf field: optional string then_path = 3
     */
    thenPath?: string;
}
/**
 * Comparison operators applied to a single field path.
 *
 * Value-typed operators intentionally use google.protobuf.Value so the JSON
 * mapping stays ergonomic for humans and AI agents. Implementations should
 * validate which operators are valid for each field and how temporal values are
 * represented.
 *
 * @generated from protobuf message tusk.drift.query.v1.FieldPredicate
 */
export interface FieldPredicate {
    /**
     * @generated from protobuf field: google.protobuf.Value eq = 1
     */
    eq?: Value;
    /**
     * @generated from protobuf field: google.protobuf.Value neq = 2
     */
    neq?: Value;
    /**
     * @generated from protobuf field: repeated google.protobuf.Value in_values = 3
     */
    inValues: Value[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Value not_in_values = 4
     */
    notInValues: Value[];
    /**
     * @generated from protobuf field: google.protobuf.Value gt = 5
     */
    gt?: Value;
    /**
     * @generated from protobuf field: google.protobuf.Value gte = 6
     */
    gte?: Value;
    /**
     * @generated from protobuf field: google.protobuf.Value lt = 7
     */
    lt?: Value;
    /**
     * @generated from protobuf field: google.protobuf.Value lte = 8
     */
    lte?: Value;
    /**
     * @generated from protobuf field: optional string contains = 9
     */
    contains?: string;
    /**
     * @generated from protobuf field: optional string starts_with = 10
     */
    startsWith?: string;
    /**
     * @generated from protobuf field: optional string ends_with = 11
     */
    endsWith?: string;
    /**
     * @generated from protobuf field: optional bool is_null = 12
     */
    isNull?: boolean;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.TimestampRange between_timestamps = 13
     */
    betweenTimestamps?: TimestampRange;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.FieldAccess access = 14
     */
    access?: FieldAccess;
}
/**
 * Recursive query clause.
 *
 * `fields` is keyed by canonical field path, for example:
 * - "name"
 * - "packageName"
 * - "statusCode"
 * - "outputValue.statusCode"
 * - "inputValue.body"
 *
 * @generated from protobuf message tusk.drift.query.v1.WhereClause
 */
export interface WhereClause {
    /**
     * @generated from protobuf field: map<string, tusk.drift.query.v1.FieldPredicate> fields = 1
     */
    fields: {
        [key: string]: FieldPredicate;
    };
    /**
     * @generated from protobuf field: repeated tusk.drift.query.v1.WhereClause and = 2
     */
    and: WhereClause[];
    /**
     * @generated from protobuf field: repeated tusk.drift.query.v1.WhereClause or = 3
     */
    or: WhereClause[];
    /**
     * @generated from protobuf field: tusk.drift.query.v1.WhereClause not = 4
     */
    not?: WhereClause;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.SpanOrderBy
 */
export interface SpanOrderBy {
    /**
     * @generated from protobuf field: tusk.drift.query.v1.SpanSortField field = 1
     */
    field: SpanSortField;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.SortDirection direction = 2
     */
    direction: SortDirection;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.MetricOrderBy
 */
export interface MetricOrderBy {
    /**
     * @generated from protobuf field: tusk.drift.query.v1.AggregateMetric metric = 1
     */
    metric: AggregateMetric;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.SortDirection direction = 2
     */
    direction: SortDirection;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.SchemaComparisonPeriod
 */
export interface SchemaComparisonPeriod {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 1
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 2
     */
    endDate?: Timestamp;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.QuerySpansRequest
 */
export interface QuerySpansRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string client_id = 2
     */
    clientId?: string;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.WhereClause where = 3
     */
    where?: WhereClause;
    /**
     * @generated from protobuf field: repeated tusk.drift.query.v1.SpanOrderBy order_by = 4
     */
    orderBy: SpanOrderBy[];
    /**
     * @generated from protobuf field: optional int32 limit = 5
     */
    limit?: number;
    /**
     * @generated from protobuf field: optional int32 offset = 6
     */
    offset?: number;
    /**
     * @generated from protobuf field: optional bool include_payloads = 7
     */
    includePayloads?: boolean;
    /**
     * @generated from protobuf field: optional int32 max_payload_length = 8
     */
    maxPayloadLength?: number;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.GetSchemaRequest
 */
export interface GetSchemaRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string package_name = 2
     */
    packageName?: string;
    /**
     * @generated from protobuf field: optional string instrumentation_name = 3
     */
    instrumentationName?: string;
    /**
     * @generated from protobuf field: optional string name = 4
     */
    name?: string;
    /**
     * @generated from protobuf field: optional bool show_example = 5
     */
    showExample?: boolean;
    /**
     * @generated from protobuf field: optional int32 max_payload_length = 6
     */
    maxPayloadLength?: number;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.ListDistinctValuesRequest
 */
export interface ListDistinctValuesRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string client_id = 2
     */
    clientId?: string;
    /**
     * @generated from protobuf field: string field = 3
     */
    field: string;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.WhereClause where = 4
     */
    where?: WhereClause;
    /**
     * @generated from protobuf field: optional int32 limit = 5
     */
    limit?: number;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.AggregateSpansRequest
 */
export interface AggregateSpansRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string client_id = 2
     */
    clientId?: string;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.WhereClause where = 3
     */
    where?: WhereClause;
    /**
     * @generated from protobuf field: repeated tusk.drift.query.v1.AggregateGroupField group_by = 4
     */
    groupBy: AggregateGroupField[];
    /**
     * @generated from protobuf field: repeated tusk.drift.query.v1.AggregateMetric metrics = 5
     */
    metrics: AggregateMetric[];
    /**
     * @generated from protobuf field: tusk.drift.query.v1.TimeBucket time_bucket = 6
     */
    timeBucket: TimeBucket;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.MetricOrderBy order_by = 7
     */
    orderBy?: MetricOrderBy;
    /**
     * @generated from protobuf field: optional int32 limit = 8
     */
    limit?: number;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.GetTraceSpansRequest
 */
export interface GetTraceSpansRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string client_id = 2
     */
    clientId?: string;
    /**
     * @generated from protobuf field: string trace_id = 3
     */
    traceId: string;
    /**
     * @generated from protobuf field: optional bool include_payloads = 4
     */
    includePayloads?: boolean;
    /**
     * @generated from protobuf field: optional int32 max_payload_length = 5
     */
    maxPayloadLength?: number;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.GetSpansByIdsRequest
 */
export interface GetSpansByIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: repeated string ids = 2
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated tusk.drift.query.v1.SelectableSpanField fields = 3
     */
    fields: SelectableSpanField[];
    /**
     * @generated from protobuf field: optional bool include_payloads = 4
     */
    includePayloads?: boolean;
    /**
     * @generated from protobuf field: optional int32 max_payload_length = 5
     */
    maxPayloadLength?: number;
}
/**
 * @generated from protobuf message tusk.drift.query.v1.CompareSchemaRequest
 */
export interface CompareSchemaRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string client_id = 2
     */
    clientId?: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.SchemaComparisonPeriod period_a = 4
     */
    periodA?: SchemaComparisonPeriod;
    /**
     * @generated from protobuf field: tusk.drift.query.v1.SchemaComparisonPeriod period_b = 5
     */
    periodB?: SchemaComparisonPeriod;
    /**
     * @generated from protobuf field: optional bool include_payloads = 6
     */
    includePayloads?: boolean;
    /**
     * @generated from protobuf field: optional int32 max_payload_length = 7
     */
    maxPayloadLength?: number;
}
// Canonical shared query schema for filtering and analyzing recorded spans.
// 
// This package intentionally models the user-facing query shape shared by the
// backend, MCP tools, and CLI instead of a lower-level AST that each client
// would need to translate. Implementations are responsible for runtime
// validation of field keys, operator compatibility, and JSON access rules.

/**
 * Selectable fields when fetching spans by ID.
 *
 * @generated from protobuf enum tusk.drift.query.v1.SelectableSpanField
 */
export enum SelectableSpanField {
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_ID = 1;
     */
    ID = 1,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_SPAN_ID = 2;
     */
    SPAN_ID = 2,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_TRACE_ID = 3;
     */
    TRACE_ID = 3,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_PARENT_SPAN_ID = 4;
     */
    PARENT_SPAN_ID = 4,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_NAME = 5;
     */
    NAME = 5,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_KIND = 6;
     */
    KIND = 6,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_STATUS = 7;
     */
    STATUS = 7,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_TIMESTAMP = 8;
     */
    TIMESTAMP = 8,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_DURATION = 9;
     */
    DURATION = 9,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_IS_ROOT_SPAN = 10;
     */
    IS_ROOT_SPAN = 10,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_METADATA = 11;
     */
    METADATA = 11,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_PACKAGE_NAME = 12;
     */
    PACKAGE_NAME = 12,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_INSTRUMENTATION_NAME = 13;
     */
    INSTRUMENTATION_NAME = 13,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_INPUT_VALUE = 14;
     */
    INPUT_VALUE = 14,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_OUTPUT_VALUE = 15;
     */
    OUTPUT_VALUE = 15,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_INPUT_SCHEMA = 16;
     */
    INPUT_SCHEMA = 16,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_OUTPUT_SCHEMA = 17;
     */
    OUTPUT_SCHEMA = 17,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_ENVIRONMENT = 18;
     */
    ENVIRONMENT = 18,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_CREATED_AT = 19;
     */
    CREATED_AT = 19,
    /**
     * @generated from protobuf enum value: SELECTABLE_SPAN_FIELD_UPDATED_AT = 20;
     */
    UPDATED_AT = 20
}
/**
 * JSON-backed columns that support JSONPath extraction.
 *
 * @generated from protobuf enum tusk.drift.query.v1.JsonColumn
 */
export enum JsonColumn {
    /**
     * @generated from protobuf enum value: JSON_COLUMN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: JSON_COLUMN_INPUT_VALUE = 1;
     */
    INPUT_VALUE = 1,
    /**
     * @generated from protobuf enum value: JSON_COLUMN_OUTPUT_VALUE = 2;
     */
    OUTPUT_VALUE = 2,
    /**
     * @generated from protobuf enum value: JSON_COLUMN_METADATA = 3;
     */
    METADATA = 3,
    /**
     * @generated from protobuf enum value: JSON_COLUMN_STATUS = 4;
     */
    STATUS = 4
}
/**
 * Optional cast applied before comparisons.
 *
 * @generated from protobuf enum tusk.drift.query.v1.CastType
 */
export enum CastType {
    /**
     * @generated from protobuf enum value: CAST_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAST_TYPE_TEXT = 1;
     */
    TEXT = 1,
    /**
     * @generated from protobuf enum value: CAST_TYPE_INT = 2;
     */
    INT = 2,
    /**
     * @generated from protobuf enum value: CAST_TYPE_FLOAT = 3;
     */
    FLOAT = 3,
    /**
     * @generated from protobuf enum value: CAST_TYPE_BOOLEAN = 4;
     */
    BOOLEAN = 4
}
/**
 * Optional decoding applied before an additional JSONPath extraction.
 *
 * @generated from protobuf enum tusk.drift.query.v1.DecodeStrategy
 */
export enum DecodeStrategy {
    /**
     * @generated from protobuf enum value: DECODE_STRATEGY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DECODE_STRATEGY_BASE64 = 1;
     */
    BASE64 = 1
}
/**
 * @generated from protobuf enum tusk.drift.query.v1.SortDirection
 */
export enum SortDirection {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    ASC = 1,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    DESC = 2
}
/**
 * @generated from protobuf enum tusk.drift.query.v1.SpanSortField
 */
export enum SpanSortField {
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_TIMESTAMP = 1;
     */
    TIMESTAMP = 1,
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_CREATED_AT = 2;
     */
    CREATED_AT = 2,
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_UPDATED_AT = 3;
     */
    UPDATED_AT = 3,
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_DURATION = 4;
     */
    DURATION = 4,
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_NAME = 5;
     */
    NAME = 5,
    /**
     * @generated from protobuf enum value: SPAN_SORT_FIELD_TRACE_ID = 6;
     */
    TRACE_ID = 6
}
/**
 * @generated from protobuf enum tusk.drift.query.v1.AggregateMetric
 */
export enum AggregateMetric {
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_COUNT = 1;
     */
    COUNT = 1,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_ERROR_COUNT = 2;
     */
    ERROR_COUNT = 2,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_ERROR_RATE = 3;
     */
    ERROR_RATE = 3,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_AVG_DURATION = 4;
     */
    AVG_DURATION = 4,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_MIN_DURATION = 5;
     */
    MIN_DURATION = 5,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_MAX_DURATION = 6;
     */
    MAX_DURATION = 6,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_P50_DURATION = 7;
     */
    P50_DURATION = 7,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_P95_DURATION = 8;
     */
    P95_DURATION = 8,
    /**
     * @generated from protobuf enum value: AGGREGATE_METRIC_P99_DURATION = 9;
     */
    P99_DURATION = 9
}
/**
 * @generated from protobuf enum tusk.drift.query.v1.AggregateGroupField
 */
export enum AggregateGroupField {
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_KIND = 2;
     */
    KIND = 2,
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_PACKAGE_NAME = 3;
     */
    PACKAGE_NAME = 3,
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_INSTRUMENTATION_NAME = 4;
     */
    INSTRUMENTATION_NAME = 4,
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_ENVIRONMENT = 5;
     */
    ENVIRONMENT = 5,
    /**
     * @generated from protobuf enum value: AGGREGATE_GROUP_FIELD_STATUS_CODE = 6;
     */
    STATUS_CODE = 6
}
/**
 * @generated from protobuf enum tusk.drift.query.v1.TimeBucket
 */
export enum TimeBucket {
    /**
     * @generated from protobuf enum value: TIME_BUCKET_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TIME_BUCKET_HOUR = 1;
     */
    HOUR = 1,
    /**
     * @generated from protobuf enum value: TIME_BUCKET_DAY = 2;
     */
    DAY = 2,
    /**
     * @generated from protobuf enum value: TIME_BUCKET_WEEK = 3;
     */
    WEEK = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class TimestampRange$Type extends MessageType<TimestampRange> {
    constructor() {
        super("tusk.drift.query.v1.TimestampRange", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TimestampRange>): TimestampRange {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TimestampRange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TimestampRange): TimestampRange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start */ 1:
                    message.start = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.start);
                    break;
                case /* google.protobuf.Timestamp end */ 2:
                    message.end = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.end);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TimestampRange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start = 1; */
        if (message.start)
            Timestamp.internalBinaryWrite(message.start, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end = 2; */
        if (message.end)
            Timestamp.internalBinaryWrite(message.end, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.TimestampRange
 */
export const TimestampRange = new TimestampRange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldAccess$Type extends MessageType<FieldAccess> {
    constructor() {
        super("tusk.drift.query.v1.FieldAccess", [
            { no: 1, name: "cast_as", kind: "enum", T: () => ["tusk.drift.query.v1.CastType", CastType, "CAST_TYPE_"] },
            { no: 2, name: "decode", kind: "enum", T: () => ["tusk.drift.query.v1.DecodeStrategy", DecodeStrategy, "DECODE_STRATEGY_"] },
            { no: 3, name: "then_path", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FieldAccess>): FieldAccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.castAs = 0;
        message.decode = 0;
        if (value !== undefined)
            reflectionMergePartial<FieldAccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FieldAccess): FieldAccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.query.v1.CastType cast_as */ 1:
                    message.castAs = reader.int32();
                    break;
                case /* tusk.drift.query.v1.DecodeStrategy decode */ 2:
                    message.decode = reader.int32();
                    break;
                case /* optional string then_path */ 3:
                    message.thenPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FieldAccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.query.v1.CastType cast_as = 1; */
        if (message.castAs !== 0)
            writer.tag(1, WireType.Varint).int32(message.castAs);
        /* tusk.drift.query.v1.DecodeStrategy decode = 2; */
        if (message.decode !== 0)
            writer.tag(2, WireType.Varint).int32(message.decode);
        /* optional string then_path = 3; */
        if (message.thenPath !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.thenPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.FieldAccess
 */
export const FieldAccess = new FieldAccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldPredicate$Type extends MessageType<FieldPredicate> {
    constructor() {
        super("tusk.drift.query.v1.FieldPredicate", [
            { no: 1, name: "eq", kind: "message", T: () => Value },
            { no: 2, name: "neq", kind: "message", T: () => Value },
            { no: 3, name: "in_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Value },
            { no: 4, name: "not_in_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Value },
            { no: 5, name: "gt", kind: "message", T: () => Value },
            { no: 6, name: "gte", kind: "message", T: () => Value },
            { no: 7, name: "lt", kind: "message", T: () => Value },
            { no: 8, name: "lte", kind: "message", T: () => Value },
            { no: 9, name: "contains", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "starts_with", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "ends_with", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_null", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "between_timestamps", kind: "message", T: () => TimestampRange },
            { no: 14, name: "access", kind: "message", T: () => FieldAccess }
        ]);
    }
    create(value?: PartialMessage<FieldPredicate>): FieldPredicate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inValues = [];
        message.notInValues = [];
        if (value !== undefined)
            reflectionMergePartial<FieldPredicate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FieldPredicate): FieldPredicate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Value eq */ 1:
                    message.eq = Value.internalBinaryRead(reader, reader.uint32(), options, message.eq);
                    break;
                case /* google.protobuf.Value neq */ 2:
                    message.neq = Value.internalBinaryRead(reader, reader.uint32(), options, message.neq);
                    break;
                case /* repeated google.protobuf.Value in_values */ 3:
                    message.inValues.push(Value.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Value not_in_values */ 4:
                    message.notInValues.push(Value.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Value gt */ 5:
                    message.gt = Value.internalBinaryRead(reader, reader.uint32(), options, message.gt);
                    break;
                case /* google.protobuf.Value gte */ 6:
                    message.gte = Value.internalBinaryRead(reader, reader.uint32(), options, message.gte);
                    break;
                case /* google.protobuf.Value lt */ 7:
                    message.lt = Value.internalBinaryRead(reader, reader.uint32(), options, message.lt);
                    break;
                case /* google.protobuf.Value lte */ 8:
                    message.lte = Value.internalBinaryRead(reader, reader.uint32(), options, message.lte);
                    break;
                case /* optional string contains */ 9:
                    message.contains = reader.string();
                    break;
                case /* optional string starts_with */ 10:
                    message.startsWith = reader.string();
                    break;
                case /* optional string ends_with */ 11:
                    message.endsWith = reader.string();
                    break;
                case /* optional bool is_null */ 12:
                    message.isNull = reader.bool();
                    break;
                case /* tusk.drift.query.v1.TimestampRange between_timestamps */ 13:
                    message.betweenTimestamps = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.betweenTimestamps);
                    break;
                case /* tusk.drift.query.v1.FieldAccess access */ 14:
                    message.access = FieldAccess.internalBinaryRead(reader, reader.uint32(), options, message.access);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FieldPredicate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Value eq = 1; */
        if (message.eq)
            Value.internalBinaryWrite(message.eq, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Value neq = 2; */
        if (message.neq)
            Value.internalBinaryWrite(message.neq, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Value in_values = 3; */
        for (let i = 0; i < message.inValues.length; i++)
            Value.internalBinaryWrite(message.inValues[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Value not_in_values = 4; */
        for (let i = 0; i < message.notInValues.length; i++)
            Value.internalBinaryWrite(message.notInValues[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Value gt = 5; */
        if (message.gt)
            Value.internalBinaryWrite(message.gt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Value gte = 6; */
        if (message.gte)
            Value.internalBinaryWrite(message.gte, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Value lt = 7; */
        if (message.lt)
            Value.internalBinaryWrite(message.lt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Value lte = 8; */
        if (message.lte)
            Value.internalBinaryWrite(message.lte, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional string contains = 9; */
        if (message.contains !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.contains);
        /* optional string starts_with = 10; */
        if (message.startsWith !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.startsWith);
        /* optional string ends_with = 11; */
        if (message.endsWith !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.endsWith);
        /* optional bool is_null = 12; */
        if (message.isNull !== undefined)
            writer.tag(12, WireType.Varint).bool(message.isNull);
        /* tusk.drift.query.v1.TimestampRange between_timestamps = 13; */
        if (message.betweenTimestamps)
            TimestampRange.internalBinaryWrite(message.betweenTimestamps, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.query.v1.FieldAccess access = 14; */
        if (message.access)
            FieldAccess.internalBinaryWrite(message.access, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.FieldPredicate
 */
export const FieldPredicate = new FieldPredicate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WhereClause$Type extends MessageType<WhereClause> {
    constructor() {
        super("tusk.drift.query.v1.WhereClause", [
            { no: 1, name: "fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FieldPredicate } },
            { no: 2, name: "and", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WhereClause },
            { no: 3, name: "or", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WhereClause },
            { no: 4, name: "not", kind: "message", T: () => WhereClause }
        ]);
    }
    create(value?: PartialMessage<WhereClause>): WhereClause {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fields = {};
        message.and = [];
        message.or = [];
        if (value !== undefined)
            reflectionMergePartial<WhereClause>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WhereClause): WhereClause {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, tusk.drift.query.v1.FieldPredicate> fields */ 1:
                    this.binaryReadMap1(message.fields, reader, options);
                    break;
                case /* repeated tusk.drift.query.v1.WhereClause and */ 2:
                    message.and.push(WhereClause.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated tusk.drift.query.v1.WhereClause or */ 3:
                    message.or.push(WhereClause.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* tusk.drift.query.v1.WhereClause not */ 4:
                    message.not = WhereClause.internalBinaryRead(reader, reader.uint32(), options, message.not);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: WhereClause["fields"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof WhereClause["fields"] | undefined, val: WhereClause["fields"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FieldPredicate.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.query.v1.WhereClause.fields");
            }
        }
        map[key ?? ""] = val ?? FieldPredicate.create();
    }
    internalBinaryWrite(message: WhereClause, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, tusk.drift.query.v1.FieldPredicate> fields = 1; */
        for (let k of globalThis.Object.keys(message.fields)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FieldPredicate.internalBinaryWrite(message.fields[k], writer, options);
            writer.join().join();
        }
        /* repeated tusk.drift.query.v1.WhereClause and = 2; */
        for (let i = 0; i < message.and.length; i++)
            WhereClause.internalBinaryWrite(message.and[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated tusk.drift.query.v1.WhereClause or = 3; */
        for (let i = 0; i < message.or.length; i++)
            WhereClause.internalBinaryWrite(message.or[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.query.v1.WhereClause not = 4; */
        if (message.not)
            WhereClause.internalBinaryWrite(message.not, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.WhereClause
 */
export const WhereClause = new WhereClause$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpanOrderBy$Type extends MessageType<SpanOrderBy> {
    constructor() {
        super("tusk.drift.query.v1.SpanOrderBy", [
            { no: 1, name: "field", kind: "enum", T: () => ["tusk.drift.query.v1.SpanSortField", SpanSortField, "SPAN_SORT_FIELD_"] },
            { no: 2, name: "direction", kind: "enum", T: () => ["tusk.drift.query.v1.SortDirection", SortDirection, "SORT_DIRECTION_"] }
        ]);
    }
    create(value?: PartialMessage<SpanOrderBy>): SpanOrderBy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.field = 0;
        message.direction = 0;
        if (value !== undefined)
            reflectionMergePartial<SpanOrderBy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpanOrderBy): SpanOrderBy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.query.v1.SpanSortField field */ 1:
                    message.field = reader.int32();
                    break;
                case /* tusk.drift.query.v1.SortDirection direction */ 2:
                    message.direction = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SpanOrderBy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.query.v1.SpanSortField field = 1; */
        if (message.field !== 0)
            writer.tag(1, WireType.Varint).int32(message.field);
        /* tusk.drift.query.v1.SortDirection direction = 2; */
        if (message.direction !== 0)
            writer.tag(2, WireType.Varint).int32(message.direction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.SpanOrderBy
 */
export const SpanOrderBy = new SpanOrderBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricOrderBy$Type extends MessageType<MetricOrderBy> {
    constructor() {
        super("tusk.drift.query.v1.MetricOrderBy", [
            { no: 1, name: "metric", kind: "enum", T: () => ["tusk.drift.query.v1.AggregateMetric", AggregateMetric, "AGGREGATE_METRIC_"] },
            { no: 2, name: "direction", kind: "enum", T: () => ["tusk.drift.query.v1.SortDirection", SortDirection, "SORT_DIRECTION_"] }
        ]);
    }
    create(value?: PartialMessage<MetricOrderBy>): MetricOrderBy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metric = 0;
        message.direction = 0;
        if (value !== undefined)
            reflectionMergePartial<MetricOrderBy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricOrderBy): MetricOrderBy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.query.v1.AggregateMetric metric */ 1:
                    message.metric = reader.int32();
                    break;
                case /* tusk.drift.query.v1.SortDirection direction */ 2:
                    message.direction = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricOrderBy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.query.v1.AggregateMetric metric = 1; */
        if (message.metric !== 0)
            writer.tag(1, WireType.Varint).int32(message.metric);
        /* tusk.drift.query.v1.SortDirection direction = 2; */
        if (message.direction !== 0)
            writer.tag(2, WireType.Varint).int32(message.direction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.MetricOrderBy
 */
export const MetricOrderBy = new MetricOrderBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SchemaComparisonPeriod$Type extends MessageType<SchemaComparisonPeriod> {
    constructor() {
        super("tusk.drift.query.v1.SchemaComparisonPeriod", [
            { no: 1, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_date", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SchemaComparisonPeriod>): SchemaComparisonPeriod {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SchemaComparisonPeriod>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SchemaComparisonPeriod): SchemaComparisonPeriod {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start_date */ 1:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 2:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SchemaComparisonPeriod, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start_date = 1; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 2; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.SchemaComparisonPeriod
 */
export const SchemaComparisonPeriod = new SchemaComparisonPeriod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuerySpansRequest$Type extends MessageType<QuerySpansRequest> {
    constructor() {
        super("tusk.drift.query.v1.QuerySpansRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "where", kind: "message", T: () => WhereClause },
            { no: 4, name: "order_by", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpanOrderBy },
            { no: 5, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "offset", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "include_payloads", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "max_payload_length", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<QuerySpansRequest>): QuerySpansRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.orderBy = [];
        if (value !== undefined)
            reflectionMergePartial<QuerySpansRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuerySpansRequest): QuerySpansRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* tusk.drift.query.v1.WhereClause where */ 3:
                    message.where = WhereClause.internalBinaryRead(reader, reader.uint32(), options, message.where);
                    break;
                case /* repeated tusk.drift.query.v1.SpanOrderBy order_by */ 4:
                    message.orderBy.push(SpanOrderBy.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional int32 limit */ 5:
                    message.limit = reader.int32();
                    break;
                case /* optional int32 offset */ 6:
                    message.offset = reader.int32();
                    break;
                case /* optional bool include_payloads */ 7:
                    message.includePayloads = reader.bool();
                    break;
                case /* optional int32 max_payload_length */ 8:
                    message.maxPayloadLength = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QuerySpansRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string client_id = 2; */
        if (message.clientId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* tusk.drift.query.v1.WhereClause where = 3; */
        if (message.where)
            WhereClause.internalBinaryWrite(message.where, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated tusk.drift.query.v1.SpanOrderBy order_by = 4; */
        for (let i = 0; i < message.orderBy.length; i++)
            SpanOrderBy.internalBinaryWrite(message.orderBy[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 limit = 5; */
        if (message.limit !== undefined)
            writer.tag(5, WireType.Varint).int32(message.limit);
        /* optional int32 offset = 6; */
        if (message.offset !== undefined)
            writer.tag(6, WireType.Varint).int32(message.offset);
        /* optional bool include_payloads = 7; */
        if (message.includePayloads !== undefined)
            writer.tag(7, WireType.Varint).bool(message.includePayloads);
        /* optional int32 max_payload_length = 8; */
        if (message.maxPayloadLength !== undefined)
            writer.tag(8, WireType.Varint).int32(message.maxPayloadLength);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.QuerySpansRequest
 */
export const QuerySpansRequest = new QuerySpansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSchemaRequest$Type extends MessageType<GetSchemaRequest> {
    constructor() {
        super("tusk.drift.query.v1.GetSchemaRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "package_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "instrumentation_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "show_example", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "max_payload_length", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetSchemaRequest>): GetSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSchemaRequest): GetSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string package_name */ 2:
                    message.packageName = reader.string();
                    break;
                case /* optional string instrumentation_name */ 3:
                    message.instrumentationName = reader.string();
                    break;
                case /* optional string name */ 4:
                    message.name = reader.string();
                    break;
                case /* optional bool show_example */ 5:
                    message.showExample = reader.bool();
                    break;
                case /* optional int32 max_payload_length */ 6:
                    message.maxPayloadLength = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string package_name = 2; */
        if (message.packageName !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.packageName);
        /* optional string instrumentation_name = 3; */
        if (message.instrumentationName !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.instrumentationName);
        /* optional string name = 4; */
        if (message.name !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* optional bool show_example = 5; */
        if (message.showExample !== undefined)
            writer.tag(5, WireType.Varint).bool(message.showExample);
        /* optional int32 max_payload_length = 6; */
        if (message.maxPayloadLength !== undefined)
            writer.tag(6, WireType.Varint).int32(message.maxPayloadLength);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.GetSchemaRequest
 */
export const GetSchemaRequest = new GetSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDistinctValuesRequest$Type extends MessageType<ListDistinctValuesRequest> {
    constructor() {
        super("tusk.drift.query.v1.ListDistinctValuesRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "field", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "where", kind: "message", T: () => WhereClause },
            { no: 5, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListDistinctValuesRequest>): ListDistinctValuesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.field = "";
        if (value !== undefined)
            reflectionMergePartial<ListDistinctValuesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListDistinctValuesRequest): ListDistinctValuesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string field */ 3:
                    message.field = reader.string();
                    break;
                case /* tusk.drift.query.v1.WhereClause where */ 4:
                    message.where = WhereClause.internalBinaryRead(reader, reader.uint32(), options, message.where);
                    break;
                case /* optional int32 limit */ 5:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListDistinctValuesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string client_id = 2; */
        if (message.clientId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string field = 3; */
        if (message.field !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.field);
        /* tusk.drift.query.v1.WhereClause where = 4; */
        if (message.where)
            WhereClause.internalBinaryWrite(message.where, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 limit = 5; */
        if (message.limit !== undefined)
            writer.tag(5, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.ListDistinctValuesRequest
 */
export const ListDistinctValuesRequest = new ListDistinctValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AggregateSpansRequest$Type extends MessageType<AggregateSpansRequest> {
    constructor() {
        super("tusk.drift.query.v1.AggregateSpansRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "where", kind: "message", T: () => WhereClause },
            { no: 4, name: "group_by", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["tusk.drift.query.v1.AggregateGroupField", AggregateGroupField, "AGGREGATE_GROUP_FIELD_"] },
            { no: 5, name: "metrics", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["tusk.drift.query.v1.AggregateMetric", AggregateMetric, "AGGREGATE_METRIC_"] },
            { no: 6, name: "time_bucket", kind: "enum", T: () => ["tusk.drift.query.v1.TimeBucket", TimeBucket, "TIME_BUCKET_"] },
            { no: 7, name: "order_by", kind: "message", T: () => MetricOrderBy },
            { no: 8, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AggregateSpansRequest>): AggregateSpansRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.groupBy = [];
        message.metrics = [];
        message.timeBucket = 0;
        if (value !== undefined)
            reflectionMergePartial<AggregateSpansRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AggregateSpansRequest): AggregateSpansRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* tusk.drift.query.v1.WhereClause where */ 3:
                    message.where = WhereClause.internalBinaryRead(reader, reader.uint32(), options, message.where);
                    break;
                case /* repeated tusk.drift.query.v1.AggregateGroupField group_by */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.groupBy.push(reader.int32());
                    else
                        message.groupBy.push(reader.int32());
                    break;
                case /* repeated tusk.drift.query.v1.AggregateMetric metrics */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.metrics.push(reader.int32());
                    else
                        message.metrics.push(reader.int32());
                    break;
                case /* tusk.drift.query.v1.TimeBucket time_bucket */ 6:
                    message.timeBucket = reader.int32();
                    break;
                case /* tusk.drift.query.v1.MetricOrderBy order_by */ 7:
                    message.orderBy = MetricOrderBy.internalBinaryRead(reader, reader.uint32(), options, message.orderBy);
                    break;
                case /* optional int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AggregateSpansRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string client_id = 2; */
        if (message.clientId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* tusk.drift.query.v1.WhereClause where = 3; */
        if (message.where)
            WhereClause.internalBinaryWrite(message.where, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated tusk.drift.query.v1.AggregateGroupField group_by = 4; */
        if (message.groupBy.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.groupBy.length; i++)
                writer.int32(message.groupBy[i]);
            writer.join();
        }
        /* repeated tusk.drift.query.v1.AggregateMetric metrics = 5; */
        if (message.metrics.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.metrics.length; i++)
                writer.int32(message.metrics[i]);
            writer.join();
        }
        /* tusk.drift.query.v1.TimeBucket time_bucket = 6; */
        if (message.timeBucket !== 0)
            writer.tag(6, WireType.Varint).int32(message.timeBucket);
        /* tusk.drift.query.v1.MetricOrderBy order_by = 7; */
        if (message.orderBy)
            MetricOrderBy.internalBinaryWrite(message.orderBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 limit = 8; */
        if (message.limit !== undefined)
            writer.tag(8, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.AggregateSpansRequest
 */
export const AggregateSpansRequest = new AggregateSpansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceSpansRequest$Type extends MessageType<GetTraceSpansRequest> {
    constructor() {
        super("tusk.drift.query.v1.GetTraceSpansRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_payloads", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "max_payload_length", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetTraceSpansRequest>): GetTraceSpansRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.traceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetTraceSpansRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceSpansRequest): GetTraceSpansRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string trace_id */ 3:
                    message.traceId = reader.string();
                    break;
                case /* optional bool include_payloads */ 4:
                    message.includePayloads = reader.bool();
                    break;
                case /* optional int32 max_payload_length */ 5:
                    message.maxPayloadLength = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceSpansRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string client_id = 2; */
        if (message.clientId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string trace_id = 3; */
        if (message.traceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.traceId);
        /* optional bool include_payloads = 4; */
        if (message.includePayloads !== undefined)
            writer.tag(4, WireType.Varint).bool(message.includePayloads);
        /* optional int32 max_payload_length = 5; */
        if (message.maxPayloadLength !== undefined)
            writer.tag(5, WireType.Varint).int32(message.maxPayloadLength);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.GetTraceSpansRequest
 */
export const GetTraceSpansRequest = new GetTraceSpansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpansByIdsRequest$Type extends MessageType<GetSpansByIdsRequest> {
    constructor() {
        super("tusk.drift.query.v1.GetSpansByIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fields", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["tusk.drift.query.v1.SelectableSpanField", SelectableSpanField, "SELECTABLE_SPAN_FIELD_"] },
            { no: 4, name: "include_payloads", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "max_payload_length", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetSpansByIdsRequest>): GetSpansByIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.ids = [];
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<GetSpansByIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSpansByIdsRequest): GetSpansByIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* repeated string ids */ 2:
                    message.ids.push(reader.string());
                    break;
                case /* repeated tusk.drift.query.v1.SelectableSpanField fields */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.fields.push(reader.int32());
                    else
                        message.fields.push(reader.int32());
                    break;
                case /* optional bool include_payloads */ 4:
                    message.includePayloads = reader.bool();
                    break;
                case /* optional int32 max_payload_length */ 5:
                    message.maxPayloadLength = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSpansByIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* repeated string ids = 2; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.ids[i]);
        /* repeated tusk.drift.query.v1.SelectableSpanField fields = 3; */
        if (message.fields.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.fields.length; i++)
                writer.int32(message.fields[i]);
            writer.join();
        }
        /* optional bool include_payloads = 4; */
        if (message.includePayloads !== undefined)
            writer.tag(4, WireType.Varint).bool(message.includePayloads);
        /* optional int32 max_payload_length = 5; */
        if (message.maxPayloadLength !== undefined)
            writer.tag(5, WireType.Varint).int32(message.maxPayloadLength);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.GetSpansByIdsRequest
 */
export const GetSpansByIdsRequest = new GetSpansByIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompareSchemaRequest$Type extends MessageType<CompareSchemaRequest> {
    constructor() {
        super("tusk.drift.query.v1.CompareSchemaRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "period_a", kind: "message", T: () => SchemaComparisonPeriod },
            { no: 5, name: "period_b", kind: "message", T: () => SchemaComparisonPeriod },
            { no: 6, name: "include_payloads", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "max_payload_length", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CompareSchemaRequest>): CompareSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CompareSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CompareSchemaRequest): CompareSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* tusk.drift.query.v1.SchemaComparisonPeriod period_a */ 4:
                    message.periodA = SchemaComparisonPeriod.internalBinaryRead(reader, reader.uint32(), options, message.periodA);
                    break;
                case /* tusk.drift.query.v1.SchemaComparisonPeriod period_b */ 5:
                    message.periodB = SchemaComparisonPeriod.internalBinaryRead(reader, reader.uint32(), options, message.periodB);
                    break;
                case /* optional bool include_payloads */ 6:
                    message.includePayloads = reader.bool();
                    break;
                case /* optional int32 max_payload_length */ 7:
                    message.maxPayloadLength = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CompareSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string client_id = 2; */
        if (message.clientId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* tusk.drift.query.v1.SchemaComparisonPeriod period_a = 4; */
        if (message.periodA)
            SchemaComparisonPeriod.internalBinaryWrite(message.periodA, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.query.v1.SchemaComparisonPeriod period_b = 5; */
        if (message.periodB)
            SchemaComparisonPeriod.internalBinaryWrite(message.periodB, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional bool include_payloads = 6; */
        if (message.includePayloads !== undefined)
            writer.tag(6, WireType.Varint).bool(message.includePayloads);
        /* optional int32 max_payload_length = 7; */
        if (message.maxPayloadLength !== undefined)
            writer.tag(7, WireType.Varint).int32(message.maxPayloadLength);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.query.v1.CompareSchemaRequest
 */
export const CompareSchemaRequest = new CompareSchemaRequest$Type();
